// extracted by mini-css-extract-plugin
module.exports = {"player":"FPf1ST","playButton":"U7iumB"};